import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';

import { ProfileService } from '@dp/core/services/profile.service';
import { Observable, of } from 'rxjs';

import { MemberProfile } from '@lib/core/models/member.interface';

export const memberProfileResolver: ResolveFn<MemberProfile | null> = (route: ActivatedRouteSnapshot): Observable<MemberProfile | null> => {
  const profileService = inject(ProfileService);
  const helsiPatientId = route.paramMap.get('helsiPatientId');

  if (!helsiPatientId) return of(null);
  else return profileService.getMemberProfileByHelsiId(helsiPatientId);
};
